import { z } from "zod";

export const MaintenanceStatusResponseSchema = z.object({
  isMaintenanceMode: z.boolean(),
  message: z.string(),
});
export type MaintenanceStatusResponse = z.infer<typeof MaintenanceStatusResponseSchema>;
